import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

const fmt = (n: number): string => n.toLocaleString('en-US');

/** App-wide paginator labels: "Rows per page" and a compact range with thousands separators, "1–25 of 1,354". */
@Injectable()
export class NumberFormatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Rows per page';
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) return `0 of ${fmt(length)}`;
    const start = page * pageSize;
    const end = start < length ? Math.min(start + pageSize, length) : start + pageSize;
    return `${fmt(start + 1)}–${fmt(end)} of ${fmt(length)}`;
  };
}

